export default __webpack_public_path__ + "static/media/imc-inner-2.7c1ed364.jpg";